





















import Vue from 'vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import AboutGyyms from '@/components/top/AboutGyyms.vue'
import UsageFlows from '@/components/top/UsageFlows.vue'
import { Meta } from '@/tools/page'

const PAGE_TITLE = 'サービスについて'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'GYYM(ジーム)は様々なジムのプログラムを都度利用できるサービスです。入会金なしで今話題のフィットネスや人気のプログラムを受講することができます。支払いも都度払いなので月額料金はかかりません。GYYMを使って気軽にフィットネスを始めましょう！',
  },
]

export default Vue.extend({
  components: {
    PageDefaultLayout,
    AboutGyyms,
    UsageFlows,
  },
  created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
  },
})
